import { BookOpen, Database, Search, FileText } from "lucide-react";
import heroImage from "@/assets/hero-person-male-friendly.png";
import ProductHeroI18n from "../shared/ProductHeroI18n";

const KnowledgeBaseHero = () => {
  return (
    <ProductHeroI18n
      translationPrefix="knowledgeBasePage"
      heroImage={heroImage}
      imageAlt="Chathero AI Knowledge Base"
      floatingIcons={[
        { icon: BookOpen, color: "mint" },
        { icon: Database, color: "orange" },
        { icon: Search, color: "primary" },
        { icon: FileText, color: "mint" },
      ]}
    />
  );
};

export default KnowledgeBaseHero;
